import React from 'react';
import {useIntl} from 'react-intl';

import {type Channel} from '@mattermost/types/channels';

import Constants from 'utils/constants';

import {EditorWrapper} from './wrapper';

export const CanPostOnlyInThread = ({channelType}: {channelType: Channel['type']}) => {
    const {formatMessage} = useIntl();

    const isDirectOrGroup = channelType === Constants.DM_CHANNEL || channelType === Constants.GM_CHANNEL;

    return (
        <EditorWrapper>
            {formatMessage({
                id: isDirectOrGroup ? 'editor_state.can_post_only_in_direct_threads' : 'editor_state.can_post_only_in_channel_threads',
                defaultMessage: isDirectOrGroup ? 'The chat is read-only, but you can send a message to the threads' : 'The channel is read-only, but you can send a message to the threads',
            })}
        </EditorWrapper>
    );
};
